import { stripHtmlWhitespace } from "./zone_content"
import { formatNumber } from "@ciq/shared/utils/format"

/**
 * Generate popup HTML content for flow line features at a hover point.
 * Follows the raw HTML pattern from zone_content.js (NOT React components).
 *
 * @param {Array<Object>} features - Array of GeoJSON features from queryRenderedFeatures
 * @returns {string} HTML string for mapboxgl.Popup.setHTML()
 */
export function generateFlowPopupContent(features) {
  if (!features?.length) return ""

  // Sort by volume descending (highest first)
  const sorted = [...features].sort(
    (a, b) => (b.properties.volume ?? 0) - (a.properties.volume ?? 0)
  )

  let html = '<div class="flow-popup">'

  if (sorted.length > 1) {
    html += `<div class="flow-popup__header">${sorted.length} routes</div>`
  }

  html += '<div class="flow-popup__routes">'

  for (const feature of sorted) {
    const { originName, destinationName, volume } = feature.properties
    const displayVolume = typeof volume === "number" ? formatNumber(volume) : "\u2014"

    html += `
    <div class="flow-popup__route">
      <div class="flow-popup__route-path">
        <span class="flow-popup__route-origin">${originName || "Unknown"}</span>
        <span class="flow-popup__route-arrow">\u2192</span>
        <span class="flow-popup__route-dest">${destinationName || "Unknown"}</span>
      </div>
      <div class="flow-popup__route-volume">${displayVolume} trips</div>
    </div>`
  }

  html += "</div></div>"
  return stripHtmlWhitespace(html)
}
